const style = {
  colors: {
    background: '#F6F5FC',
    primary: {
      lighter: '#E0E3FF',
      light: '#6674F4',
      main: '#5061FC',
      dark: '#3346F0',
    },
    gray: {
      900: '#222222',
      200: '#BCBCBC',
      100: '#E5E5E5',
    },
    danger: {
      light: '#F97171',
      main: '#FC5050',
      dark: '#F63131',
    },
    success: {
      main: '#51CA73',
    },
  },
};

export default style;